import React from 'react';
import { Icon } from '../core/Icon.jsx';

/**
 * SearchField — rounded search input with leading magnifier, matching the
 * app's "Buscar cliente o plan…" bar.
 */
export function SearchField({ placeholder = 'Buscar…', style = {}, ...rest }) {
  const [focus, setFocus] = React.useState(false);
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      height: 'var(--control-h)',
      padding: '0 18px',
      background: 'var(--input-bg)',
      border: `${focus ? 2 : 1}px solid ${focus ? 'var(--primary)' : 'var(--border)'}`,
      borderRadius: 'var(--radius)',
      transition: 'border-color .15s ease',
      ...style,
    }}>
      <Icon name="search" size={20} color="var(--text-faint)" />
      <input
        placeholder={placeholder}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        style={{
          flex: 1,
          border: 'none',
          background: 'transparent',
          outline: 'none',
          color: 'var(--text-body)',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--fs-body)',
          fontWeight: 'var(--fw-medium)',
        }}
        {...rest}
      />
    </div>
  );
}
